import { usePermissions } from '~/composables/use-permissions';

export default defineNuxtRouteMiddleware(() => {
  const { isAdmin, isOwner } = usePermissions();

  if (!isAdmin.value && !isOwner.value) {
    return abortNavigation({ statusCode: 403 });
  }
});
